export default defineAppConfig({
  foundationLayer: {},
});

declare module "@nuxt/schema" {
  interface AppConfigInput {
    foundationLayer?: {};
  }
}
